import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import L from "leaflet";
import { Link } from "react-router-dom";

const TIER_COLORS = { 0: "#64748B", 1: "#D97706", 2: "#0D9488", 3: "#059669" };

function pinIcon(tier) {
  const color = TIER_COLORS[tier] || TIER_COLORS[0];
  return L.divIcon({
    className: "",
    html: `<div class="tier-pin" style="background:${color}"></div>`,
    iconSize: [26, 26],
    iconAnchor: [13, 26],
    popupAnchor: [0, -24],
  });
}

export function MapView({ orgs, center = [11.2, 77.5], zoom = 9 }) {
  return (
    <MapContainer center={center} zoom={zoom} scrollWheelZoom={true} className="h-full w-full">
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <MarkerClusterGroup chunkedLoading>
      {orgs.map((o) => (
        <Marker key={o.id} position={[o.lat, o.lng]} icon={pinIcon(o.verification_tier)}>
          <Popup>
            <div className="w-44">
              <img src={o.hero_image} alt={o.display_name} className="w-full h-20 object-cover rounded mb-1.5" />
              <div className="font-bold text-stone-900 text-sm leading-tight">{o.display_name}</div>
              <div className="text-xs text-stone-500 mb-1">{o.district}, {o.state}</div>
              <Link to={`/ngo/${o.id}`} className="text-xs font-semibold text-terracotta" data-testid={`map-popup-link-${o.id}`}>View profile →</Link>
            </div>
          </Popup>
        </Marker>
      ))}
      </MarkerClusterGroup>
    </MapContainer>
  );
}

export default MapView;
